import { read } from '@/api/rest';

const personPublic = {
  index: async (options) => await read('/person-public?' + options.toString()),
  view: async (id) => await read('/person-public/' + id),
};
export default personPublic;
